<div class="main-content" id="main-content">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="br-breadcrumb">
            <ul class="crumb-list">
              <li class="crumb home">
                <a class="br-button circle" [routerLink]="['/']"
                  ><span class="sr-only">Página inicial</span
                  ><i class="fas fa-home"></i
                ></a>
              </li>
              <li class="crumb" data-active="active">
                <i class="icon fas fa-chevron-right"></i
                ><span>Resultados da pesquisa</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="page-header">
            <div id="page-title" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h2>Resultados da pesquisa</h2>
              </div>
            </div>

            <app-barra-busca
              [componenteRef]="componenteRef"
              (inputEvent)="receiveInput($event)"
              [labelInput]="labelInput"
              [filtroArea]="false"
              [filtros]="false"
              [mensagem]="mensagem"
            ></app-barra-busca>

            <div id="results">
              <div
                class="row articles"
                *ngFor="let resultado of resultadosBusca"
              >
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <app-card
                    [titulo]="resultado.nome || resultado.pergunta"
                    [texto]="resultado.resposta || resultado.descricao"
                    [tipo]="resultado.tipo"
                    [id]="
                      resultado.tipo === 'mudaramnome'
                        ? resultado.cursoAtualId
                        : resultado.id
                    "
                    [eixo]="resultado.eixoId > 0 ? resultado.idAux : null"
                    [eixoNome]="
                      resultado.eixoNome.length > 0 ? resultado.eixoNome : null
                    "
                    [cursoAtual]="
                      resultado.cursoAtualNome.length > 0
                        ? resultado.cursoAtualNome
                        : null
                    "
                    [componenteRef]="componenteRef"
                    [link]="resultado.link"
                  ></app-card>
                </div>
              </div>
            </div>
            <ng-container *ngIf="totalResultados">
              <app-paginacao
                [paginaAtual]="paginaAtual"
                [totalPaginas]="totalPaginas"
                (mudouPagina)="onPaginaSelecionada($event)"
              ></app-paginacao>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- <app-em-breve-aviso></app-em-breve-aviso> -->
